import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/sticky-footer/sticky-footer.module.css
var css_248z = ".sticky-footer-module_footer__aqAba {\n    box-shadow: 0 -5px 14px 0 rgba(27, 31, 50, 0.16);\n}\n";
var sticky_footer_module_default = { "footer": "sticky-footer-module_footer__aqAba" };
style_inject_es_default(css_248z);

//#endregion
export { sticky_footer_module_default as default };